import React from 'react'
import { connect, useSelector } from 'react-redux'
import { PublicPageWrapper, PublicContentWrapper } from './styled'
import { Helmet } from 'react-helmet'

const publicRoute = ( routeConfig = {}) => {
  return ( Component ) => {
    const PublicRouteWrapper = ( props ) => {
      const { meta } = routeConfig
      return (
          <>
            <Helmet {...meta} />
            <PublicPageWrapper>
              <PublicContentWrapper>
                <Component {...props} />
              </PublicContentWrapper>
            </PublicPageWrapper>
          </>
        )
    }
    return connect()( PublicRouteWrapper )
  }
}

export default publicRoute
